import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=2fc0d094&scoped=true"
import script from "./menu.vue?vue&type=script&setup=true&lang=js"
export * from "./menu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=2fc0d094&prod&lang=scss&scoped=true"
import style1 from "./menu.vue?vue&type=style&index=1&id=2fc0d094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0d094",
  null
  
)

export default component.exports